import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../style.js';
import { withStyles } from '@material-ui/core/styles';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import ProductGroup from '../ProductGroup';
import MUList from '../../../../ui/MUList';
import MUListItem from '../../../../ui/MUListItem';
import MUListItemText from '../../../../ui/MuListItemText';
import MUCollapse from '../../../../ui/MUCollapse';
import _ from 'lodash';

class ProductTab extends React.Component {
  handleClick = (e, id) => {
    this.props.switchDocsMainContentToInfo();
    this.props.setDocsApiInfo(id, null, false);
    this.props.toggleSection(id); 
  };

  render() {
    const { classes, list, name, id, expandedSections, products } = this.props;

    const isOpen = !!expandedSections[id]; 

    const isSelected =
      localStorage.getItem('apiDocs') === id ||
      localStorage.getItem('baasDocs') === id ||
      products.infoContent.content === id ||
      list.some(x => x.id === products.infoContent.content);
      

    return (
      <div>
        <MUList className={classes.list} component="nav">
          <MUListItem
            button
            selected={isSelected}
            onClick={(e) => this.handleClick(e, id)}
            classes={{
              root: classes.listItem,
              selected: classes.selected
            }}
          >
            <MUListItemText
              inset={false}
              classes={{ primary: classes.listItemText }}
              primary={name}
            />
            {isOpen ? <ExpandLess /> : <ExpandMore />}
          </MUListItem>

          {!_.isNil(list) && (
            <MUCollapse
              in={isOpen}
              timeout="auto"
              unmountOnExit
              classes={{ entered: classes.collapse }}
            >
              {list.map(group => (
                <div key={group.id}>
                  <ProductGroup {...this.props} group={group} />
                </div>
              ))}
            </MUCollapse>
          )}
        </MUList>
      </div>
    );
  }
}

ProductTab.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  products: PropTypes.object.isRequired,
  expandedSections: PropTypes.object.isRequired,
  toggleSection: PropTypes.func.isRequired
};

export default withStyles(styles)(ProductTab);
